import * as actionTypes from "./bodyDrawerActions";

const bodyDrawerState = {
  tabName: null,
};

const bodyDrawerReducer = (state = bodyDrawerState, action) => {
  switch (action.type) {
    case actionTypes.TAB_CLICKED:
      return {
        ...state,
        tabName: action.tabName,
      };

    case actionTypes.BACK_CLICKED:
      return {
        ...state,
        tabName: null,
      };

    default:
      return state;
  }
};

export default bodyDrawerReducer;
